import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    userDetails: {},
}

const viewUserSlice = createSlice({
    name: 'viewUser',
    initialState,
    reducers: {
        defaultState(state, action) {
            return initialState
        },
        setUserObject(state, action) {
            return { ...state, ...action?.payload }
        },
    }
})
export const viewUserActions = viewUserSlice.actions;
export default viewUserSlice;
